module.exports = __webpack_public_path__ + "img/94.41cdc7fb.jpg";